<script>
import EditUser from "../data/EditUser";
import UserValidator from "../data/UserValidator";

import PropertyTable from "../../../common/property-table.vue"
import {propertyListHeight, translations} from "../data/variables";

export default {
    name: 'user-wizard-grouping',
    computed: {
        translations() {
            return translations
        },
        invalidUsergroups() {
            return this.validator.validateUsergroups(this.user);
        },
        invalidPrivilegegroups() {
            return this.validator.validatePrivilegegroups(this.user);
        },
        propertyListHeight() {
            return propertyListHeight
        }
    },
    components: {PropertyTable},
    props: {
        currentlyManagedProjectId: Number,
        user: EditUser,
        validator: UserValidator
    },
    data() {
        return {
            translateUsergroup(invalidProjects) {
                const names = invalidProjects.map(project => project.name).join(', ');
                return Lang.langGet('You must select at least one usergroup in :projects', {projects: names});
            },
            translatePrivilegegroup(invalidProjects) {
                const names = invalidProjects.map(project => project.name).join(', ');
                return Lang.langGet('You must select at least one privilegegroup in :projects', {projects: names});
            }
        }
    },
    mounted() {
        // initial validation
        this.$emit('valid', 'privilegegroups');
        this.$emit('valid', 'usergroups');
    }
}
</script>

<template>
    <div class="d-flex flex-column h-100 overflow-y-hidden">
        <div class="d-flex flex-row w-50 pa-2">
            <v-select-custom
                :value="currentlyManagedProjectId"
                @input="value => $emit('input','currentlyManagedProjectId', value)"
                :items="user.getProjectNamesForDropDown()"
                itemText="name"
                itemValue="id"
                :label="translations.currentlyManaged"
                popup-used-in-modal
            />
        </div>
        <div class="d-flex flex-row h-100 overflow-y-hidden">
            <div class="d-flex flex-column w-50 pa-2">
                <property-table
                    :providedMaxHeight="propertyListHeight - 10"
                    :items="user.getUsergroupsGroupedByProject(currentlyManagedProjectId, true)"
                    :propertyName="translations.usergroup"
                    searchable
                    @input="value => $emit('input', 'usergroups', value)"
                    @selectAll="value => $emit('selectAll', 'usergroups', value)"
                />
            </div>
            <div class="d-flex flex-column flex-grow-1 pa-2">
                <property-table
                    :providedMaxHeight="propertyListHeight - 10"
                    :items="user.getPrivilegeGroupByProject(currentlyManagedProjectId, true)"
                    :propertyName="translations.privilegegroup"
                    searchable
                    @input="value => $emit('input', 'privilegegroups', value)"
                    @selectAll="value => $emit('selectAll', 'privilegegroups', value)"
                />
            </div>
        </div>
        <h3 v-if="!invalidUsergroups.valid" class="bg-danger rounded pa-2 text-center">
            {{translateUsergroup(invalidUsergroups.projectsWithNoGroup)}}
        </h3>
        <h3 v-if="!invalidPrivilegegroups.valid" class="bg-danger rounded pa-2 text-center">
            {{translatePrivilegegroup(invalidPrivilegegroups.projectsWithNoGroup)}}
        </h3>
    </div>
</template>
